/**
 * QA-536 — 국내 전화번호를 하이픈 형식으로(010-1234-5678, 02-123-4567, 1588-1234). 해외 번호(+로 시작)나
 * 규칙에 맞지 않는 값은 손대지 않고 그대로 돌려준다(잘못 끊는 것보다 원문이 낫다).
 */
export const formatPhoneNumber = (raw: string | null | undefined): string | null => {
  const v = raw?.trim();
  if (!v) return null;
  if (v.startsWith('+')) return v;
  const d = v.replace(/\D/g, '');
  if (/^01\d{9}$/.test(d)) return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
  if (/^01\d{8}$/.test(d)) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  if (/^02\d{8}$/.test(d)) return `02-${d.slice(2, 6)}-${d.slice(6)}`;
  if (/^02\d{7}$/.test(d)) return `02-${d.slice(2, 5)}-${d.slice(5)}`;
  if (/^0[3-9]\d{9}$/.test(d)) return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
  if (/^0[3-9]\d{8}$/.test(d)) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  if (/^1[5-9]\d{6}$/.test(d)) return `${d.slice(0, 4)}-${d.slice(4)}`;
  return v;
};
